module.exports = __webpack_public_path__ + "img/fourday_ps_06.0a4cab4b.jpg";